import { CollectClickedMessage, GameUIMessageType } from 'game-ui-types'

let shouldCollectAfterAnimations = false
let isListening = false

const sendCollectClicked = () => {
    window.postMessage({ type: GameUIMessageType.COLLECT_CLICKED } as CollectClickedMessage, '*')
}

const handleMessage = (event: MessageEvent) => {
    if (event.data?.type !== GameUIMessageType.PLAYER_INFO_COMPLETE_ANIMATIONS) return

    if (!shouldCollectAfterAnimations) return

    shouldCollectAfterAnimations = false

    sendCollectClicked()
}

export const collectUltraPlayWin = () => {
    if (!isListening) {
        window.addEventListener('message', handleMessage, false)
        isListening = true
    }

    // We are trying to collect but the first collect clicked message may only cancel the win animations.
    // That's why we schedule another one once the animations are complete.
    shouldCollectAfterAnimations = true

    sendCollectClicked()
}

export const cancelPendingUltraPlayCollect = () => {
    shouldCollectAfterAnimations = false
}
